export const EBigJobType = {
  "0": "UNKNOWN",
  "1": "REPORT_ADMIN_ACC_TRX",
  "2": "REPORT_ADMIN_ACC_TRX_LONG_TERM",
  "3": "HOTEL_GIATA_MAPPING",
  "-1": "ALL"
};

export const EBigJobStatus = {
  "0": "UNKNOWN",
  "1": "NEW",
  "2": "LISTED",
  "3": "TRIGGERED",
  "4": "RUNNING",
  "5": "COMPLETED",
  "6": "ERROR",
  "-1": "ALL"
};